import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@guildeducationinc/recess';
import { Chip } from '@mui/material';
import { RuleType } from '@src/types';
import { FilterBuilder, RuleTargetType, useLocale } from 'pe-core-frontend';
import { AcademicPolicy } from './AcademicPolicy';
import { ApprovalChainPolicy } from './ApprovalChainPolicy';
import { ClawbackPolicy } from './ClawbackPolicy';
import { EligibilityPolicy } from './EligibilityPolicy';
import { ExpensePolicy } from './ExpensePolicy';
import { FieldOfStudyPolicy } from './FieldOfStudyPolicy';
import { FundingPolicy } from './FundingPolicy';
import { PointInTimeEligibilityPolicy } from './PointInTimeEligibilityPolicy';
import { ProgramPolicy } from './ProgramPolicy';
import { RuleExceptionStatusTag } from './RuleExceptionStatusTag';
import styles from './Rules.module.scss';
import { SchoolPolicy } from './SchoolPolicy';
import { TerminationPolicy } from './TerminationPolicy';
export const ReadonlyRuleSnapshot = ({ ruleSnapshot, clientId, targetPopulationEntityEnumType = {}, defaultTargetPopulationEntityType = '', }) => {
    const { t } = useLocale();
    const renderPolicyByType = () => {
        const policyProps = {
            clientId,
            policy: ruleSnapshot.policy,
            onChange: () => { },
            readonly: true,
        };
        switch (ruleSnapshot.ruleType) {
            case RuleType.ELIGIBILITY:
                return _jsx(EligibilityPolicy, { ...policyProps });
            case RuleType.POINT_IN_TIME_ELIGIBILITY:
                return _jsx(PointInTimeEligibilityPolicy, { ...policyProps });
            case RuleType.FUNDING:
                return _jsx(FundingPolicy, { ...policyProps });
            case RuleType.ACADEMIC:
                return _jsx(AcademicPolicy, { ...policyProps });
            case RuleType.PROGRAM:
                return _jsx(ProgramPolicy, { ...policyProps });
            case RuleType.FIELD_OF_STUDY:
                return _jsx(FieldOfStudyPolicy, { ...policyProps });
            case RuleType.APPROVAL_CHAIN:
                return _jsx(ApprovalChainPolicy, { ...policyProps });
            case RuleType.TERMINATION:
                return _jsx(TerminationPolicy, { ...policyProps });
            case RuleType.SCHOOL:
                return _jsx(SchoolPolicy, { ...policyProps });
            case RuleType.EXPENSE:
                return _jsx(ExpensePolicy, { ...policyProps });
            case RuleType.CLAWBACK:
                return _jsx(ClawbackPolicy, { ...policyProps });
            default:
                return (_jsxs("div", { className: 'text-sm text-gray-600', children: [t('Unknown rule type'), ": ", ruleSnapshot.ruleType] }));
        }
    };
    return (_jsx(Card, { children: _jsx(CardContent, { className: styles.ruleCard, children: _jsxs("div", { className: styles.ruleContent, children: [_jsx("div", { className: styles.policy, children: renderPolicyByType() }), _jsxs("div", { className: styles.target, children: [ruleSnapshot.isException && (_jsx(RuleExceptionStatusTag, { startsOn: ruleSnapshot.startsOn, expiresOn: ruleSnapshot.expiresOn, comment: ruleSnapshot.comment })), _jsxs("div", { className: 'flex flexItems--center', children: [t('Applies To'), ":\u00A0\u00A0", ruleSnapshot.target === RuleTargetType.ALL && (_jsx(Chip, { variant: 'outlined', label: t('Everyone') }))] }), ruleSnapshot.target !== RuleTargetType.ALL && ruleSnapshot.criteria && (_jsx(FilterBuilder, { clientId: clientId, criteria: ruleSnapshot.criteria, entityEnumType: targetPopulationEntityEnumType, hideName: true, initialCondition: true, defaultEntityType: defaultTargetPopulationEntityType, readonly: true, customizedMessaging: true }))] })] }) }) }));
};
